import React from 'react';
import SalesForceFunctional from './components/salesforceFunctional';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const SalesForcePage = ({}) => {
	return <SalesForceFunctional />;
};
const ReducedScreen = withReducer('WelcomePage', reducer, sagas)(SalesForcePage);
export default ReducedScreen;
